import React from 'react';
import cx from 'classnames';
import { Theme, mapThemeToClassNames } from 'ui/themes';

type Props = {
    header?: React.ReactNode;
    content?: React.ReactNode;
    footer?: React.ReactNode;
    progress?: React.ReactNode;
    mobilePanel?: React.ReactNode;
    modal?: React.ReactNode;
    cta?: React.ReactNode;
    cookieNotification?: React.ReactNode;
    theme?: Theme;
    extraClass?: string;
    jsClass?: string;
    contentCenter?: boolean;
    headerCenter?: boolean;
    isGlowing?: boolean;
};

function Page(props: Props) {
    const {
        header,
        content,
        footer,
        progress,
        mobilePanel,
        modal,
        cta,
        cookieNotification,
        theme = Theme.DATE,
        extraClass,
        jsClass = 'js-mobile-panel-parent',
        contentCenter,
        headerCenter,
        isGlowing,
    } = props;

    const className = {
        block: cx({
            page: true,
            [mapThemeToClassNames[theme]]: true,
            [extraClass as string]: extraClass,
            [jsClass]: jsClass,
        }),
        header: cx({
            page__header: true,
            'page__header--center': headerCenter,
        }),
        content: cx({
            page__content: true,
            'page__content--align-center': contentCenter,
        }),
    };

    const animatedContent = (
        <div className="page__corners">
            <div className="page__corner page__corner--bottom-left" />
            <div className="page__corner page__corner--top-right" />
        </div>
    );

    return (
        <main className={className.block}>
            {isGlowing ? animatedContent : null}

            {header ? <header className={className.header}>{header}</header> : null}

            {content ? <div className={className.content}>{content}</div> : null}

            {footer ? <footer className="page__footer">{footer}</footer> : null}

            {progress ? <div className="page__progress">{progress}</div> : null}

            {mobilePanel ? <div className="page__mobile-panel">{mobilePanel}</div> : null}

            {modal ? <div className="page__modal">{modal}</div> : null}

            {cta ? (
                <div className="page__modal-content" style={{ display: 'none' }} aria-hidden="true">
                    <div data-modal-container="js-form-download-app">{cta}</div>
                </div>
            ) : null}

            {cookieNotification ? (
                <div className="page__cookie-notification">{cookieNotification}</div>
            ) : null}
        </main>
    );
}

Page.Theme = Theme;

export default Page;
